import * as z from 'zod';
import { FIRST_PAGE } from '@noor/config';

/** Default rows per page — the sibling Субъекты tables (merchants, tokens) use 10. */
export const SYSTEM_USERS_PAGE_SIZE = 20;

/**
 * URL search-param schema for the system-users surface. The route's
 * `validateSearch` uses it, so the URL is the single source of truth for the
 * typed search, the role/status filters, and pagination.
 */
export const systemUserListSearchSchema = z.object({
  // Typed search (merchants `merchantListSearchSchema` parity): `search_type`
  // names the column (`SYSTEM_USER_SEARCH_TYPES`), `search_value` carries the
  // query. Both ride the wire as-is to `GET /api/v1/identities/{app}`.
  // Coerced (not strict strings): the router JSON-parses search params, so a
  // bare numeric URL (`?search_value=998901234501`, the everyday phone
  // lookup) arrives as a number — rejecting it would crash route validation
  // on bookmarks and shared links. Unknown types fall through (never crash);
  // the table falls back to the default type.
  search_type: z.coerce.string().optional(),
  search_value: z.coerce.string().optional(),
  role: z.string().optional(),
  status: z.string().optional(),
  page: z.coerce.number().int().positive().default(FIRST_PAGE),
  pageSize: z.coerce.number().int().positive().default(SYSTEM_USERS_PAGE_SIZE),
});
export type SystemUserListSearch = z.infer<typeof systemUserListSearchSchema>;
